import { Tokenizer } from "./Tokenizer";
import { Render } from "./Render";
export async function convertMDtoHTML(text) {
    const tokenizer = new Tokenizer(text);
    const renderer = new Render(tokenizer.getAST());
    return renderer.html();
}
export function convertMDtoAST(text) {
    const tokenizer = new Tokenizer(text);
    return tokenizer.getAST();
}
export function convertMDtoTokens(text) {
    const tokenizer = new Tokenizer(text);
    return tokenizer.tokens;
}
export default {
    convertMDtoHTML,
    convertMDtoAST,
    convertMDtoTokens
};
